const Alt = require('alt');
const alt = new Alt();

module.exports = alt;



// WEBPACK FOOTER //
// ./javascripts/components/alt.js